'use strict';
'use es6';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _underscore = require('../../utils/underscore');

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _classNames = require('react-utils/classNames');

var _classNames2 = _interopRequireDefault(_classNames);

var _UIButton = require('../../button/UIButton');

var _UIButton2 = _interopRequireDefault(_UIButton);

var _UIClickable = require('../../button/UIClickable');

var _UIClickable2 = _interopRequireDefault(_UIClickable);

var _ComponentWithWindowListeners = require('../../mixins/ComponentWithWindowListeners');

var _ComponentWithWindowListeners2 = _interopRequireDefault(_ComponentWithWindowListeners);

var _UIIcon = require('../../icon/UIIcon');

var _UIIcon2 = _interopRequireDefault(_UIIcon);

var _SyntheticEvent = require('../../core/SyntheticEvent');

var _SyntheticEvent2 = _interopRequireDefault(_SyntheticEvent);

var _EventHandlers = require('../../core/EventHandlers');

var _UIControlledPopover = require('../../tooltip/UIControlledPopover');

var _UIControlledPopover2 = _interopRequireDefault(_UIControlledPopover);

var _UIPopoverArrow = require('../../tooltip/UIPopoverArrow');

var _UIPopoverArrow2 = _interopRequireDefault(_UIPopoverArrow);

var _UIDropdownCaret = require('../UIDropdownCaret');

var _UIDropdownCaret2 = _interopRequireDefault(_UIDropdownCaret);

var _customRenderer = require('../../utils/propTypes/customRenderer');

var CustomRenderer = _interopRequireWildcard(_customRenderer);

var _PlacementConstants = require('../../tooltip/PlacementConstants');

var _Tether = require('../../constants/Tether');

var _Functions = require('../../core/Functions');

var _iconName = require('../../utils/propTypes/iconName');

var _component = require('../../utils/propTypes/component');

var _component2 = _interopRequireDefault(_component);

var _focusStylesListener = require('../../listeners/focusStylesListener');

var _decorators = require('../../utils/propTypes/decorators');

var _sizes = require('HubStyleTokens/sizes');

var _Memoize = require('../../core/Memoize');

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }

var getArrowSize = function getArrowSize(buttonUse) {
  if (buttonUse.match(/link|transparent/)) {
    return 'medium';
  }
  return 'none';
};

var getPlacement = function getPlacement(placement, computedArrowSize) {
  if (placement) {
    return placement;
  }
  // Center if we have an arrow, otherwise flush left against the target
  if (computedArrowSize !== 'none') {
    return 'bottom';
  }
  return 'bottom right';
};

var getDistanceAdjustment = function getDistanceAdjustment(buttonSize, buttonUse) {
  if (buttonUse === 'transparent') {
    // Account for invisible padding
    var buttonPaddingY = void 0;
    if (buttonSize === 'extra-small') {
      buttonPaddingY = _sizes.BUTTON_XS_PADDING_Y;
    } else if (buttonSize === 'small') {
      buttonPaddingY = _sizes.BUTTON_SM_PADDING_Y;
    } else {
      buttonPaddingY = _sizes.BUTTON_DEFAULT_PADDING_Y;
    }
    return -parseInt(buttonPaddingY, 10);
  }
  return 0;
};

var getInsetAdjustment = function getInsetAdjustment(buttonUse, placement, computedArrowSize) {
  if (buttonUse === 'transparent' && placement === 'bottom right' && computedArrowSize === 'none') {
    // Account for invisible padding. Inset adjustments are applied twice
    // (once to the tether attachment, once to the target attachment), so
    // we halve our value here.
    return -parseInt(_sizes.BUTTON_DEFAULT_PADDING_X, 10) / 2;
  }
  return 0;
};

var getButtonClassName = function getButtonClassName(className, multiline, open, readOnly) {
  return (0, _classNames2.default)(className, 'private-button__dropdown-opener', 'uiDropdown__button', {
    'private-button__dropdown-opener--multiline': multiline,
    'private-button__dropdown-opener--open': open,
    // a 'readonly' <button> doesn't make sense, so apply class for styling here
    'private-button--readonly': readOnly
  });
};

var getStyle = function getStyle(menuWidth, controlWidth) {
  return {
    width: menuWidth || controlWidth,
    minWidth: menuWidth === 'auto' ? controlWidth : null
  };
};

var renderButtonLabel = function renderButtonLabel(buttonText, iconName, readOnly) {
  var buttonClassNames = (0, _classNames2.default)('private-dropdown__button-label', 'uiDropdown__buttonLabel', {
    'private-dropdown__button-label--no-icon': !iconName && !buttonText || readOnly
  });
  var icon = iconName ? _react2.default.createElement(_UIIcon2.default, { className: 'private-dropdown__icon', name: iconName }) : null;
  return _react2.default.createElement(
    'span',
    { className: buttonClassNames },
    icon,
    buttonText == null || buttonText === '' ? '\u200B' : buttonText
  );
};

var renderButton = function renderButton(_useNativeButton, ariaPressed, Button, buttonSize, buttonUse, open, rest, computedButtonClassName, buttonRef, dropdownId, handleButtonClick, handleKeyDown, renderedButtonLabel, renderedCaret, readOnly) {
  var ButtonType = Button || (buttonUse === 'unstyled' ? _UIClickable2.default : _UIButton2.default);
  var buttonProps = buttonUse === 'unstyled' ? {} : {
    _useNativeButton: _useNativeButton,
    size: buttonSize,
    use: buttonUse
  };

  return _react2.default.createElement(
    ButtonType,
    _extends({}, rest, buttonProps, {
      'aria-haspopup': true,
      'aria-owns': dropdownId,
      'aria-pressed': typeof ariaPressed === 'boolean' ? ariaPressed : open,
      className: computedButtonClassName,
      'data-dropdown-open': open,
      onClick: handleButtonClick,
      onKeyDown: handleKeyDown,
      buttonRef: buttonRef
    }),
    _react2.default.createElement(
      'span',
      { className: 'uiDropdown__buttonContents private-dropdown__button__contents' },
      renderedButtonLabel,
      !readOnly && renderedCaret
    )
  );
};

exports.default = _react2.default.createClass({
  displayName: 'UIAbstractDropdown',

  mixins: [_ComponentWithWindowListeners2.default],

  propTypes: {
    animateOnMount: _react.PropTypes.bool.isRequired,
    animateOnToggle: _react.PropTypes.bool,
    'aria-pressed': _react.PropTypes.bool,
    arrowColor: _react.PropTypes.string,
    arrowSize: _react.PropTypes.oneOf(Object.keys(_UIPopoverArrow2.default.ARROW_SIZES)),
    autoPlacement: _react.PropTypes.oneOfType([_react.PropTypes.bool, _react.PropTypes.oneOf(['horiz', 'vert'])]).isRequired,
    Button: _component2.default,
    buttonSize: _UIButton2.default.propTypes.size,
    buttonText: _react.PropTypes.node,
    buttonUse: _UIButton2.default.propTypes.use,
    caretRenderer: CustomRenderer.propType,
    children: _react.PropTypes.node,
    closeOnOutsideClick: _react.PropTypes.bool,
    closeOnTargetLeave: _react.PropTypes.bool,
    Content: _component2.default,
    disabled: _react.PropTypes.bool,
    dropdownClassName: _react.PropTypes.string,
    dropdownContentRef: (0, _decorators.hidden)(_react.PropTypes.func),
    iconName: (0, _iconName.getIconNamePropType)(),
    locked: _react.PropTypes.bool.isRequired,
    menuWidth: _react.PropTypes.oneOfType([_react.PropTypes.number, _react.PropTypes.oneOf(['auto'])]),
    minMenuWidth: _react.PropTypes.number.isRequired,
    multiline: (0, _decorators.hidden)(_react.PropTypes.bool.isRequired),
    onChangePlacement: _react.PropTypes.func,
    onFocusLeave: _react.PropTypes.func,
    onOpenChange: _react.PropTypes.func,
    onOpenComplete: _react.PropTypes.func,
    onOpenStart: _react.PropTypes.func,
    open: _react.PropTypes.bool.isRequired,
    pinToConstraint: _react.PropTypes.oneOfType([_react.PropTypes.bool, _react.PropTypes.arrayOf(_react.PropTypes.oneOf(_PlacementConstants.PLACEMENTS_SIDES))]),
    placement: _react.PropTypes.oneOf(_PlacementConstants.PLACEMENTS),
    popoverProps: _react.PropTypes.object,
    readOnly: _react.PropTypes.bool,
    _useMutationObserver: _react.PropTypes.bool,
    _useNativeButton: _react.PropTypes.bool
  },

  getDefaultProps: function getDefaultProps() {
    return {
      animateOnMount: false,
      autoPlacement: 'vert',
      buttonSize: 'default',
      buttonUse: 'secondary',
      caretRenderer: _react2.default.createElement(_UIDropdownCaret2.default, null),
      closeOnOutsideClick: true,
      dropdownClassName: '',
      locked: false,
      minMenuWidth: _Tether.MIN_MENU_WIDTH,
      multiline: false,
      open: false
    };
  },
  getInitialState: function getInitialState() {
    return {
      controlWidth: 0
    };
  },
  componentWillMount: function componentWillMount() {
    this._id = (0, _underscore.uniqueId)('dropdown-');
    this._getStyle = (0, _Memoize.memoizeLastResult)(getStyle);
    this._buttonRef = _react2.default.createRef ? _react2.default.createRef() : { current: null };
  },
  componentDidMount: function componentDidMount() {
    this.setState({
      controlWidth: this.computeControlWidth(this._buttonRef.current)
    });
  },
  componentDidUpdate: function componentDidUpdate(prevProps, prevState) {
    // ⚠️ This condition prevents infinite loops! ⚠️
    if (prevState.controlWidth === this.state.controlWidth) {
      this.measureControlWidth();
    }

    // If the dropdown was closed via the keyboard, and the focus was within the dropdown, then give
    // keyboard focus to the control.
    if (prevProps.open && !this.props.open && this.hasKeyboardFocus() && (0, _focusStylesListener.isPageInKeyboardMode)()) {
      this.focusOnControl();
    }
  },
  measureControlWidth: function measureControlWidth() {
    var controlEl = this._buttonRef.current;
    if (controlEl) {
      var controlWidth = this.computeControlWidth(controlEl);
      if (controlWidth !== this.state.controlWidth) {
        this.setState({
          controlWidth: controlWidth
        });
      }
    }
  },
  getWindowListeners: function getWindowListeners() {
    return {
      click: this.handleWindowClick
    };
  },
  getWindowListenersActive: function getWindowListenersActive() {
    var _props = this.props,
        closeOnOutsideClick = _props.closeOnOutsideClick,
        open = _props.open;

    return closeOnOutsideClick && open;
  },
  hasKeyboardFocus: function hasKeyboardFocus() {
    var activeElement = document.activeElement;
    var dropdownNode = document.getElementById(this._id);
    if (!activeElement) {
      return false;
    }
    if (activeElement === this._buttonRef.current) {
      return true;
    } else if (dropdownNode && dropdownNode.contains(activeElement)) {
      return true;
    }
    return false;
  },
  handleButtonClick: function handleButtonClick(evt) {
    var _props2 = this.props,
        locked = _props2.locked,
        open = _props2.open,
        onClick = _props2.onClick;

    (0, _Functions.callIfPossible)(onClick, evt);

    if (!locked) {
      var nextOpen = !open;
      this.setIsOpen(nextOpen);
    }
  },
  handleWindowClick: function handleWindowClick(evt) {
    var target = evt.target;

    // Ignore clicks on DOM elements that are no longer in the document, as
    // these can represent "inside" clicks that caused DOM mutation.
    if (!document.body.contains(target)) {
      return;
    }

    var controlNode = this._buttonRef.current;
    if (!controlNode) return;

    // Ignore clicks on the button
    if (controlNode.contains(target)) {
      return;
    }

    // Ignore clicks on any <label> that contain the button
    var parentEl = controlNode;
    while (parentEl.parentElement) {
      parentEl = parentEl.parentElement;
      if (parentEl.tagName === 'LABEL' && parentEl.contains(target)) {
        return;
      }
    }

    // Ignore clicks on any <label> whose "for" attr points to the button
    var id = controlNode.id;
    if (id) {
      var labelsForControl = document.querySelectorAll('label[for="' + id + '"]');
      for (var i = 0; i < labelsForControl.length; i++) {
        if (labelsForControl[i].contains(target)) {
          return;
        }
      }
    }

    // Ignore clicks within the dropdown
    var dropdownNode = document.getElementById(this._id);
    if (dropdownNode && (0, _EventHandlers.isClickWithinContainer)(evt, dropdownNode)) {
      return;
    }

    this.setIsOpen(false);
  },
  handleKeyDown: function handleKeyDown(evt) {
    // Handle keydown events from both the button and the dropdown
    var _props3 = this.props,
        onKeyDown = _props3.onKeyDown,
        open = _props3.open;

    if (open && evt.key === 'Escape') {
      this.setIsOpen(false);
      evt.stopPropagation();
    }
    (0, _Functions.callIfPossible)(onKeyDown, evt);
  },
  setIsOpen: function setIsOpen(nextOpen) {
    var _props4 = this.props,
        onOpenChange = _props4.onOpenChange,
        readOnly = _props4.readOnly;

    if (!onOpenChange || readOnly) {
      return;
    }
    onOpenChange((0, _SyntheticEvent2.default)(nextOpen));
  },
  focusOnControl: function focusOnControl() {
    // When focusing, we want to avoid scrolling the page
    var _window = window,
        scrollX = _window.scrollX,
        scrollY = _window.scrollY;

    var controlNode = this._buttonRef.current;
    if (!controlNode) return;
    controlNode.focus();
    window.scrollTo(scrollX, scrollY);
  },
  reposition: function reposition() {
    if (this._popoverRef) {
      this._popoverRef.reposition();
    }
  },
  computeControlWidth: function computeControlWidth(controlEl) {
    var open = this.props.open;

    if (!controlEl || !open) {
      return 0;
    }
    var exactWidth = controlEl.getBoundingClientRect().width;
    var roundedWidth = window.chrome ? Math.floor(exactWidth) : exactWidth;
    return roundedWidth - 2; // account for 1px border added by UIPopover
  },
  popoverRefCallback: function popoverRefCallback(ref) {
    this._popoverRef = ref;
  },
  renderContent: function renderContent() {
    var _props5 = this.props,
        children = _props5.children,
        Content = _props5.Content,
        dropdownClassName = _props5.dropdownClassName,
        dropdownContentRef = _props5.dropdownContentRef,
        menuWidth = _props5.menuWidth,
        minMenuWidth = _props5.minMenuWidth;


    var controlWidth = Math.max(this.state.controlWidth, minMenuWidth);

    return _react2.default.createElement(
      'div',
      {
        className: (0, _classNames2.default)('private-dropdown', 'uiDropdown__dropdown', dropdownClassName),
        id: this._id,
        onKeyDown: this.handleKeyDown,
        ref: dropdownContentRef,
        role: 'presentation',
        style: this._getStyle(menuWidth, controlWidth)
      },
      Content ? _react2.default.createElement(Content, null) : children
    );
  },
  render: function render() {
    var _props6 = this.props,
        animateOnMount = _props6.animateOnMount,
        animateOnToggle = _props6.animateOnToggle,
        ariaPressed = _props6['aria-pressed'],
        arrowColor = _props6.arrowColor,
        arrowSize = _props6.arrowSize,
        autoPlacement = _props6.autoPlacement,
        Button = _props6.Button,
        buttonSize = _props6.buttonSize,
        buttonText = _props6.buttonText,
        buttonUse = _props6.buttonUse,
        caretRenderer = _props6.caretRenderer,
        __children = _props6.children,
        className = _props6.className,
        __closeOnOutsideClick = _props6.closeOnOutsideClick,
        closeOnTargetLeave = _props6.closeOnTargetLeave,
        __Content = _props6.Content,
        __dropdownClassName = _props6.dropdownClassName,
        __dropdownContentRef = _props6.dropdownContentRef,
        iconName = _props6.iconName,
        __locked = _props6.locked,
        __menuWidth = _props6.menuWidth,
        __minMenuWidth = _props6.minMenuWidth,
        multiline = _props6.multiline,
        onChangePlacement = _props6.onChangePlacement,
        __onClick = _props6.onClick,
        onFocusLeave = _props6.onFocusLeave,
        onOpenChange = _props6.onOpenChange,
        onOpenComplete = _props6.onOpenComplete,
        onOpenStart = _props6.onOpenStart,
        open = _props6.open,
        pinToConstraint = _props6.pinToConstraint,
        placement = _props6.placement,
        popoverProps = _props6.popoverProps,
        readOnly = _props6.readOnly,
        _useMutationObserver = _props6._useMutationObserver,
        _useNativeButton = _props6._useNativeButton,
        rest = _objectWithoutProperties(_props6, ['animateOnMount', 'animateOnToggle', 'aria-pressed', 'arrowColor', 'arrowSize', 'autoPlacement', 'Button', 'buttonSize', 'buttonText', 'buttonUse', 'caretRenderer', 'children', 'className', 'closeOnOutsideClick', 'closeOnTargetLeave', 'Content', 'dropdownClassName', 'dropdownContentRef', 'iconName', 'locked', 'menuWidth', 'minMenuWidth', 'multiline', 'onChangePlacement', 'onClick', 'onFocusLeave', 'onOpenChange', 'onOpenComplete', 'onOpenStart', 'open', 'pinToConstraint', 'placement', 'popoverProps', 'readOnly', '_useMutationObserver', '_useNativeButton']);

    var computedArrowSize = arrowSize || getArrowSize(buttonUse);
    var computedButtonClassName = getButtonClassName(className, multiline, open, readOnly);
    var computedPlacement = getPlacement(placement, computedArrowSize);
    var computedDistanceAdjustment = getDistanceAdjustment(buttonSize, buttonUse);
    var computedInsetAdjustment = getInsetAdjustment(buttonUse, placement, computedArrowSize);
    var renderedButtonLabel = renderButtonLabel(buttonText, iconName, readOnly);
    var renderedCaret = CustomRenderer.render(caretRenderer, {
      use: buttonUse
    });

    return _react2.default.createElement(
      _UIControlledPopover2.default,
      _extends({
        animateOnMount: animateOnMount,
        animateOnToggle: animateOnToggle,
        arrowColor: arrowColor,
        arrowSize: computedArrowSize,
        autoPlacement: autoPlacement,
        closeOnOutsideClick: false,
        closeOnTargetLeave: closeOnTargetLeave,
        Content: this.renderContent,
        _distanceAdjustment: computedDistanceAdjustment,
        _insetAdjustment: computedInsetAdjustment,
        _useMutationObserver: _useMutationObserver,
        onFocusLeave: onFocusLeave,
        onChangePlacement: onChangePlacement,
        onOpenChange: onOpenChange,
        onOpenStart: onOpenStart,
        onOpenComplete: onOpenComplete,
        open: open,
        pinToConstraint: pinToConstraint,
        placement: computedPlacement,
        ref: this.popoverRefCallback
      }, popoverProps),
      renderButton(_useNativeButton, ariaPressed, Button, buttonSize, buttonUse, open, rest, computedButtonClassName, this._buttonRef, this._id, this.handleButtonClick, this.handleKeyDown, renderedButtonLabel, renderedCaret, readOnly)
    );
  }
});
module.exports = exports['default'];


//////////////////
// WEBPACK FOOTER
// /usr/share/hubspot/build/.hubspot/static-archive/UIComponents/static-2.2644/js/dropdown/abstract/UIAbstractDropdown.js
// module id = 324
// module chunks = 3 4 5